import { render } from "./Modal.vue?vue&type=template&id=c32a3738&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=c32a3738&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c32a3738"

export default script